export const getUrlKey = (url: string) => {
  if (!url) {
    return '';
  }
  try {
    const parsed = new URL(url, window.location.origin);
    return `${parsed.origin}${parsed.pathname}`;
  } catch {
    const [withoutHash] = url.split('#');
    return withoutHash.split('?')[0];
  }
};
